<template>
<div class="error-text">
    <slot></slot>
</div>
</template>

<script>

export default {
    name: 'ErrorMessage',
}
</script>

<style scoped>
.error-text {
    font-size: .815em;
    color: var(--input-error-color);
}
</style>